import { useState, type FormEvent } from 'react'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { BrandLogo } from '../../shared/BrandLogo'
import { useIbAuth } from '../AuthProvider'
import { IbApiError } from '../api'

export function IbLoginPage() {
  const { isAuthenticated, login } = useIbAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const from = (location.state as { from?: string } | null)?.from || '/ib'
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  if (isAuthenticated) {
    return <Navigate to="/ib" replace />
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    try {
      await login(email.trim(), password, rememberMe)
      navigate(from, { replace: true })
    } catch (err) {
      setError(err instanceof IbApiError ? err.message : 'Unable to sign in')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="ap-auth ap-auth--ib">
      <div className="ap-auth__card">
        <BrandLogo className="ap-auth__logo" tone="light" variant="mark" />
        <p className="cp-eyebrow">IB / Sub-admin</p>
        <h1>Partner portal</h1>
        <p className="cp-muted">Access your desk after Main Admin approval.</p>
        {error ? (
          <p className="cp-error" role="alert">
            {error}
          </p>
        ) : null}
        <form className="cp-auth__form" onSubmit={(e) => void onSubmit(e)}>
          <label className="cp-field">
            <span className="cp-field__label">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
            />
          </label>
          <label className="cp-field">
            <span className="cp-field__label-row">
              <span className="cp-field__label">Password</span>
              <Link className="cp-auth__forgot" to="/ib/forgot-password">
                Forgot password?
              </Link>
            </span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          <label className="cp-field ap-auth__remember">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <span>Keep me signed in on this device</span>
          </label>
          <p className="cp-muted" style={{ fontSize: '0.8rem' }}>
            Leave unchecked so closing the browser ends the session.
          </p>
          <Button type="submit" className="cp-auth__submit" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
        <p className="cp-auth__signin">
          Want to become a partner? <Link to="/ib/apply">Apply here</Link>
        </p>
      </div>
    </div>
  )
}
